module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product17-afa6d5b133420fc05c08f799c6e7a710.jpg";